export class CustomEqualitySet<T> {
  private set = new Set<T>()
  private equalityFn: (a: T, b: T) => boolean

  constructor(equalityFn: (a: T, b: T) => boolean) {
    this.equalityFn = equalityFn
  }

  add(value: T) {
    for (const existingValue of this.set) {
      if (this.equalityFn(value, existingValue)) {
        return this
      }
    }
    this.set.add(value)
    return this
  }

  has(value: T) {
    for (const existingValue of this.set) {
      if (this.equalityFn(value, existingValue)) {
        return true
      }
    }
    return false
  }

  values() {
    return this.set.values()
  }

  [Symbol.iterator]() {
    return this.set[Symbol.iterator]()
  }

  get size() {
    return this.set.size
  }

  clear() {
    this.set.clear()
  }

  delete(value: T) {
    for (const existingValue of this.set) {
      if (this.equalityFn(value, existingValue)) {
        return this.set.delete(existingValue)
      }
    }
    return false
  }

  forEach(callbackfn: (value: T, value2: T, set: Set<T>) => void, thisArg?: any) {
    return this.set.forEach(callbackfn, thisArg)
  }
}
